import { getExternalUrl } from "application/functions";
import axios from "axios";

export const axiosInstance = axios.create({
  baseURL: getExternalUrl(),
  headers: {
    "Content-Type": "application/json",
  },
});

export const axiosPostInstance = axios.create({
  baseURL: getExternalUrl(),
  headers: {
    "Content-Type": "application/json",
  },
});
